export const IMAGE = "IMAGE";
export const VIDEO = "VIDEO";
export const FILE = "FILE";
